﻿$(function () {
    $('body').on('click', '.pagination__showmore', function (e) {
        let curPage = +$(this).attr('data-current-page');
/*        SB.DotNet.invokeMethodAsync("LoadMore", curPage)
            .then((result) => {
                let nextPage = curPage + 1;
                $(this).attr('data-current-page', nextPage);
            });*/
    });
})